// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page[data-v-6ecd3b4c]{background-color:#f8f8f8}.layout[data-v-6ecd3b4c]{height:calc(100% - 1.66rem);min-height:calc(100vh - 5.11rem);padding-top:1.66rem;position:relative}.masker[data-v-6ecd3b4c]{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
